export function formatDataIdAttr(dataId: string = ''): string {
  return dataId
    .replace(/\s/g, '-')
    .replace(/_/g, '-')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .trim();
}
